module.exports = __webpack_public_path__ + "img/2.12f321d1.svg";